import React from "react";
import { Box, Typography } from "@mui/material";

const ActivitySelection = ({ activities, selectedActivity, onSelectActivity }) => (
  <Box>
    <Typography variant="subtitle1" sx={{ marginTop: "16px", marginBottom: "8px" }}>
      Activity
    </Typography>
    <Box sx={{ display: "flex", gap: "12px", overflowX: "auto", paddingBottom: "8px" }}>
      {activities.map((activity) => (
        <Box
          key={activity.label}
          onClick={() => onSelectActivity(activity.label)}
          sx={{
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: selectedActivity === activity.label ? "2px solid #4CAF50" : "2px solid transparent",
              backgroundColor: selectedActivity === activity.label ? "#E8F5E9" : "transparent",
              transition: "0.3s",
              "&:hover": {
                backgroundColor: "#F1F8E9",
              },
            }}
          >
            {activity.icon}
          </Box>
          <Typography
            variant="caption"
            sx={{
              marginTop: "4px",
              display: "block",
              fontSize: "0.75rem",
              color: "#666",
            }}
          >
            {activity.label}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

export default ActivitySelection;